import { WifiOff, RefreshCw, Loader2 } from 'lucide-react';
import { useEffect, useState } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';

interface ConnectionErrorDialogProps {
  isOpen: boolean;
  onRetry: () => void;
}

/**
 * Connection error dialog component
 */
const ConnectionErrorDialog = ({
  isOpen,
  onRetry,
}: ConnectionErrorDialogProps) => {
  const [secondsElapsed, setSecondsElapsed] = useState(0);

  // Reset timer when dialog opens/closes
  useEffect(() => {
    if (!isOpen) {
      setSecondsElapsed(0);
      return;
    }

    const interval = setInterval(() => {
      setSecondsElapsed((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen]);

  return (
    <Dialog open={isOpen}>
      <DialogContent size="md" className="sm:max-w-[425px]" hiddenCloseIcon>
        <DialogHeader className="flex flex-col items-center text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400">
            <WifiOff className="h-8 w-8" />
          </div>
          <DialogTitle className="text-xl">لا يوجد اتصال بالخادم</DialogTitle>
          <DialogDescription className="mt-2 text-center text-base">
            تعذر الاتصال بالخادم. يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة
            أخرى.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4 flex flex-col items-center gap-4">
          {/* Auto-checking indicator */}
          <div className="flex items-center gap-2 text-sm text-blue-600 dark:text-blue-400">
            <Loader2 className="h-4 w-4 animate-spin" />
            <span>جاري البحث عن الاتصال تلقائياً...</span>
          </div>

          <p className="text-sm text-muted-foreground">
            {secondsElapsed > 0 && (
              <span className="text-xs">
                (محاولة إعادة الاتصال منذ {secondsElapsed} ثانية)
              </span>
            )}
          </p>

          <p className="text-sm text-muted-foreground">
            إذا استمرت المشكلة، يرجى التواصل مع مسؤول النظام.
          </p>

          <Button onClick={onRetry} className="w-full" variant="default">
            <RefreshCw className="mr-2 h-4 w-4" />
            إعادة المحاولة الآن
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConnectionErrorDialog;
